// Mask a sign-in identifier for display in privacy-sensitive UI (e.g. the
// Sign-in methods settings screen). The user should recognize which account
// is linked without exposing the full value to anyone who glances at the
// screen.

export const maskEmail = (email: string | null | undefined): string => {
  if (!email) return "";
  const at = email.lastIndexOf("@");
  if (at <= 0) return "***";
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  const localMasked =
    local.length <= 1
      ? `${local}***`
      : `${local[0]}${"*".repeat(Math.max(3, local.length - 1))}`;
  const dot = domain.lastIndexOf(".");
  if (dot <= 0) return `${localMasked}@${domain}`;
  const domainName = domain.slice(0, dot);
  const tld = domain.slice(dot);
  const domainMasked =
    domainName.length <= 1
      ? `${domainName}***`
      : `${domainName[0]}${"*".repeat(Math.max(3, domainName.length - 1))}`;
  return `${localMasked}@${domainMasked}${tld}`;
};

export const maskPhone = (phone: string | null | undefined): string => {
  if (!phone) return "";
  // Preserve leading "+" and country prefix (up to 4 chars including "+"),
  // then mask the middle and expose the last 3 digits.
  const digitsOnly = phone.replace(/[^\d]/g, "");
  if (digitsOnly.length <= 4) return "*".repeat(digitsOnly.length);
  const hasPlus = phone.trim().startsWith("+");
  const prefixLen = Math.min(3, Math.max(1, digitsOnly.length - 6));
  const prefix = digitsOnly.slice(0, prefixLen);
  const last = digitsOnly.slice(-3);
  const middleLen = Math.max(3, digitsOnly.length - prefixLen - 3);
  return `${hasPlus ? "+" : ""}${prefix} ${"*".repeat(middleLen)} ${last}`;
};
